/** "I moved it": record that a sealed month's leftover went to GT Money Market (or elsewhere). */
import { useState } from 'react';
import { useApp } from './context';
import { Dismiss, ErrorNote, Modal } from './ui';
import { errorMessage } from '../data/repo';
import { naira } from '../lib/format';

const today = () => new Date().toISOString().slice(0, 10);

export function MoveForm({ fromMonth, amount, onClose }: { fromMonth: string; amount: number; onClose: (saved: boolean) => void }) {
  const { repo } = useApp();
  const [value, setValue] = useState(String(Math.round(amount)));
  const [destination, setDestination] = useState('GT Money Market');
  const [movedOn, setMovedOn] = useState(today());
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const n = Number(value.replace(/,/g, ''));
  const valid = Number.isFinite(n) && n > 0 && destination.trim().length > 0;
  const save = async () => {
    setBusy(true); setErr(null);
    try {
      await repo.addInvestmentMove({ from_month: fromMonth, amount: n, destination: destination.trim(), moved_on: movedOn, note: null });
      onClose(true);
    } catch (e) { setErr(errorMessage(e)); setBusy(false); }
  };
  return (
    <Modal title="I moved it" onClose={() => onClose(false)}
      footer={<><Dismiss>Cancel</Dismiss>
        <button className="cta" disabled={!valid || busy} onClick={save}>{busy ? "Saving…" : "Mark as moved"}</button></>}>
      <p className="mw-note">Do the transfer in your bank app first. This records it here; the bank alert or next statement confirms it. Nothing sealed changes.</p>
      <div className="mw-form">
        <label className="mw-field"><span>Amount moved (₦)</span><input inputMode="decimal" value={value} onChange={(e) => setValue(e.target.value)} /></label>
        <label className="mw-field"><span>Moved to</span>
          <select value={destination} onChange={(e) => setDestination(e.target.value)}>
            <option>GT Money Market</option><option>ARM</option><option>Other investment</option>
          </select></label>
        <label className="mw-field"><span>Date</span><input type="date" value={movedOn} onChange={(e) => setMovedOn(e.target.value)} /></label>
      </div>
      {err && <ErrorNote message={err} />}
    </Modal>
  );
}
